import { Button, Card, Modal, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FaqService from "../../../../service/FaqService";
import AddFaq from "./AddFaq";
import EditFaq from "./EditFaq";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { confirm } = Modal;

const Faq = () => {
  const [openAdd, setOpenAdd] = useState(false);

  const [loading, setLoading] = useState(false);

  const [openEdit, setOpenEdit] = useState({
    open: false,
    FaqId: "",
  });
  const [Faq, setFaq] = useState<any>([]);

  const showDrawerAdd = () => {
    setOpenAdd(true);
  };

  const showDrawerEdit = (record: any) => {
    setOpenEdit({ open: true, FaqId: record._id });
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      const result = await FaqService.fetchFilter(1);

      setFaq({
        data: result.data.faqs,
        total: result.data.total,
      });
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const columns = [
    // {
    //   title: "品名",
    //   dataIndex: "key",
    //   key: "key",
    // },
    {
      title: "问题kz",
      dataIndex: "questionKZ",
      key: "questionKZ",
      width: "70%",
    },

    {
      title: "更多",
      key: "action",

      render: (text: string, record: any) => (
        <>
          <Space size="middle">
            <Button
              danger
              type="primary"
              onClick={() => {
                deleteFaqConfirm(record._id);
              }}
            >
              删除
            </Button>
          </Space>
          <Space size="middle">
            <Button
              type="primary"
              onClick={() => {
                showDrawerEdit(record);
              }}
            >
              修改
            </Button>
          </Space>
        </>
      ),
    },
  ];

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setLoading(true);
    const res = await FaqService.fetchFilter(page);
    setFaq({
      data: res.data.faqs,
      total: res.data.total,
    });
    setLoading(false);
  };

  const deleteFaq = async (id: string) => {
    await FaqService.delete(id);
    window.location.reload();
  };

  const deleteFaqConfirm = (id: string) => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      title: "确认删除？",
      okText: "确认",
      cancelText: "取消",
      onOk() {
        deleteFaq(id);
      },
    });
  };

  return (
    <Card>
      <Button
        onClick={showDrawerAdd}
        style={{
          marginTop: 20,
          marginBottom: 20,
          marginLeft: 20,
          backgroundColor: "green",
        }}
        type="primary"
      >
        添加
      </Button>
      <Table
        loading={loading}
        dataSource={Faq.data}
        columns={columns}
        rowKey="_id"
        pagination={{
          pageSize: 12,
          total: Faq.total,
          onChange: pageChangeHandle,
        }}
      />
      {openAdd && <AddFaq openData={openAdd} setOpenData={setOpenAdd} />}
      {openEdit.open && (
        <EditFaq openData={openEdit} setOpenData={setOpenEdit} />
      )}
    </Card>
  );
};

export default Faq;
